import { Button, Modal, notification, Select } from 'antd'
import React, { Component } from 'react'
import { findWhere, save } from '../../../../utils/db_functions'
import { getProposalManagementStatusColor } from '../../proposal/suport-files/proposal-management-status'

export default class StatusModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            statusModal: false,
            statusLoading: false,
            status: props.status || 'Elaboração',
            proposal_code: props.proposal_code,

            proposal: this.props.proposal,
            color: 'yellow',
            label: '',
            labelColor: 'black',
        }
    }

    componentDidMount = () => {
        const status = this.props.proposal.proposal_management_status
        const color = getProposalManagementStatusColor(status, this.props.proposal.orderGenerated)
        let label = ''
        let labelColor = 'black'

        if (status === 'Negociação' || status === 'NegociaçãoSemestre') {
            label = 'N'
            labelColor = 'white'
        } else if (status === 'Cancelada') {
            label = 'X'
            labelColor = 'white'
        }

        this.setState({ color, label, labelColor })
    }

    render() {
        return (
            <div>

                <div
                    style={{
                        cursor: 'pointer',
                        backgroundColor: this.state.color,
                        width: '20px', height: '20px',
                        lineHeight: '20px',
                        margin: 'auto', borderRadius: '50%',
                        fontSize: '10px', fontWeight: 'bold',
                        color: this.state.labelColor,
                    }}
                    onClick={() => this.setState({ statusModal: true })}
                >{this.state.label}</div>

                <Modal
                    title='Atualizar Status'
                    visible={this.state.statusModal}
                    onCancel={() => this.setState({ statusModal: false, statusLoading: false })}
                    footer={[
                        <Button
                            key='send'
                            loading={this.state.statusLoading}
                            onClick={async () => {
                                this.setState({ statusLoading: true })
                                try {
                                    const proposalToUpdate = await findWhere('Proposal', 'proposal_code', [this.state.proposal_code])
                                    if (!proposalToUpdate[0]) throw new Error('Proposta não encontrada')
                                    await save('Proposal', { 'proposal_management_status': this.state.status }, proposalToUpdate[0].id)
                                    notification.success({
                                        message: 'Atualização realizada',
                                        description: 'Status alterado com sucesso.',
                                        duration: 5
                                    })
                                    window.location.reload();
                                } catch (error) {
                                    notification.error({
                                        message: 'Erro ao atualizar',
                                        description: 'Não foi possível alterar o status. Tente novamente.',
                                        duration: 5
                                    })
                                    this.setState({ statusLoading: false })
                                }
                            }}
                        >Salvar</Button>
                    ]}
                >
                    <Select
                        placeholder='Status'
                        onChange={e => this.setState({ status: e })}
                        value={this.state.status}
                        style={{ width: '100%' }}
                    >
                        <Select.Option value={null}>Selecione...</Select.Option>
                        <Select.Option value='Elaboração'>Elaboração</Select.Option>
                        <Select.Option value='Liberada'>Liberada</Select.Option>
                        <Select.Option value='Negociação'>Negociação</Select.Option>
                        <Select.Option value='Cancelada'>Cancelada</Select.Option>
                        <Select.Option value='Substituida'>Substituída</Select.Option>
                        <Select.Option value='Aprovada'>Aprovada</Select.Option>
                    </Select>
                </Modal>
            </div>
        )
    }
}
